import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useFeedbackSummary(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ["platformAnalytics", "feedbackSummary", fromDate, toDate],
    queryFn: () =>
      api.getFeedbackSummary({ from_date: fromDate, to_date: toDate }),
  });
}
